class JsonLoader {
  key = "data";

  async load(assetsPath) {
    const response = await fetch(assetsPath);

    if (!response.ok) {
      console.warn(`[AssetLoader] Failed to load JSON: ${response.statusText} (${assetsPath})`);
      return { content: {}, representation: null };
    }

    const text = await response.text();

    // Check if we received HTML instead of JSON (404 page)
    if (text.trim().startsWith('<!DOCTYPE') || text.trim().startsWith('<html')) {
      console.warn(`[AssetLoader] JSON file not found: ${assetsPath}`);
      return { content: {}, representation: null };
    }

    try {
      const content = JSON.parse(text);
      return { content, representation: null };
    } catch (e) {
      console.warn(`[AssetLoader] Invalid JSON: ${assetsPath}`);
      return { content: {}, representation: null };
    }
  }
}

const jsonLoader = new JsonLoader();
export { jsonLoader, JsonLoader };
